function OpenMortgagePanel()
{
    if ($('#HouseholdWithMortgage:checkbox:checked').length > 0) {
        $('#mortgagePnl').css('display', 'block');
    } else {
        $('#mortgagePnl').css('display', 'none');
    }
};

function mortgageTypeSelect(e) {
    if ($(e).is(':checked')) {
        $(e).prop('checked', true);
    } else {
        $(e).prop('checked', false);
    }
    UpdateMortgageTypeSelection();
};

function UpdateMortgageTypeSelection() {
    var $mortgageTypeSelections = $('#formMortgageContainer input#SerializedMortgageType:hidden');

    var mortgageTypeSelections = new Array();
    $('.mortgageSelection input:checkbox:checked').each(function (i, o) {
        mortgageTypeSelections.push($(o).attr('id') + ':' + $(o).val());
    });
    $mortgageTypeSelections.val(mortgageTypeSelections.join('~'));
};

function MortgageInterestRateSelected() {
    var mortgageInterestRateFromStr = $("#MortgageInterestRateFromVal option:selected").text();
    $("#FromMortgageInterestRateSelected").val(mortgageInterestRateFromStr);

    var mortgageInterestRateToStr = $("#MortgageInterestRateToVal option:selected").text();
    $("#ToMortgageInterestRateSelected").val(mortgageInterestRateToStr);
};

function MortgageAmountSelected() {
    var mortgageAmountFromStr = $("#MortgageAmountFromVal option:selected").text();
    $("#FromMortgageAmountSelected").val(mortgageAmountFromStr);

    var mortgageAmountToStr = $("#MortgageAmountToVal option:selected").text();
    $("#ToMortgageAmountSelected").val(mortgageAmountToStr);
};

function MortgageSaleDateSelected() {
    var mortgageSaleMonthFromStr = $("#MortgageSaleDateFromVal option:selected").text();
    $("#FromMortgageSaleDateSelected").val(mortgageSaleMonthFromStr);

    var mortgageSaleYearFromStr = $("#MortgageSaleYearFromVal option:selected").text();
    $("#FromMortgageSaleYearSelected").val(mortgageSaleYearFromStr);

    var mortgageSaleMonthToStr = $("#MortgageSaleDateToVal option:selected").text();
    $("#ToMortgageSaleDateSelected").val(mortgageSaleMonthToStr);

    var mortgageSaleYearToStr = $("#MortgageSaleYearToVal option:selected").text();
    $("#ToMortgageSaleYearSelected").val(mortgageSaleYearToStr);
};

$(function () {
    UpdateMortgageTypeSelection();
});

